import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { makeTranslateService } from 'src/data/services/common/translate/translate-service-factory';
import { LanguageKey } from 'src/main/translate/language-key/language-key';
import { TranslateKeyPipe } from '../../../pipes/translate-key/translate-key.pipe';

@Component({
  selector: 'app-topbar-user-menu',
  standalone: true,
  imports: [CommonModule, TranslateKeyPipe],
  templateUrl: './topbar-user-menu.component.html',
  styleUrls: ['./topbar-user-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarUserMenuComponent {
  @Input() userName = 'Usuário';
  @Input() userEmail = '';

  @Output() accountClick = new EventEmitter<void>();
  @Output() helpClick = new EventEmitter<void>();
  @Output() logoutClick = new EventEmitter<void>();

  menuVisible = false;

  protected translateService = makeTranslateService();
  public languageKey = LanguageKey;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  get userInitials(): string {
    const initials = (this.userName || 'Usuário')
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() || '')
      .join('');

    return initials || 'US';
  }

  toggleMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.menuVisible = !this.menuVisible;
  }

  onAccountClick(event: MouseEvent): void {
    event.stopPropagation();
    this.menuVisible = false;
    this.accountClick.emit();
  }

  onHelpClick(event: MouseEvent): void {
    event.stopPropagation();
    this.menuVisible = false;
    this.helpClick.emit();
  }

  onLogoutClick(event: MouseEvent): void {
    event.stopPropagation();
    this.menuVisible = false;
    this.logoutClick.emit();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.menuVisible) {
      return;
    }

    const target = event.target as Node | null;
    if (target && !this.elementRef.nativeElement.contains(target)) {
      this.menuVisible = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.menuVisible = false;
  }
}
